import React, { useState, useEffect, useContext } from "react";
import StateContext from "../StateContext";
import DispatchContext from "../DispatchContext";
import { useTheme } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import InputAdornment from "@material-ui/core/InputAdornment";

import Axios from "axios";
import Page from "./Page";
// Mui Components
import {
  Select,
  Button,
  FormControl,
  MenuItem,
  InputLabel,
  TextField,
} from "@material-ui/core/";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  wrapper: {
    marginTop: "1.5rem",
    position: "relative",
  },
  buttonSuccess: {
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
  },
  fabProgress: {
    color: green[500],
    position: "absolute",
    top: -6,
    left: -6,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

function KYC() {
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [updateData, setUpdateData] = useState({
    iban: appState.iban ? appState.iban : "",
  });
  const [selectedDate, setSelectedDate] = useState(appState.profile.dob);
  const [alertMessage, setAlertMessage] = useState({
    open: false,
    message: "",
    alertSuccess: false,
  });
  const ibanNumber = appState.profile.meta.iban
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}customer/profile`,
        {
          iban: updateData.iban,
        },
        {
          headers: {
            Authorization: `Bearer ${appState.token}`,
          },
        }
      );
      setLoading(false);
    } catch (e) {
      setAlertMessage({
        open: true,
        message: "There is some error updating your profile, Please try again!",
        alertSuccess: false,
      });

    }
  };

  const updateField = (e) => {
    setUpdateData({
      ...updateData,
      [e.target.name]: e.target.value,
    });
  };
  useEffect(() => {
    setTimeout(
      () => setAlertMessage({ open: false, message: "", alertSuccess: false }),
      8000
    );
  }, [alertMessage.open]);

  return (
    <div className="mt-2">
      <form
        className={`form`}
        onSubmit={handleSubmit}
        noValidate
        autoComplete="off"
      >
        <TextField
          id="iban_field"
          name="iban"
          onChange={updateField}
          value={ibanNumber? ibanNumber : updateData.iban}
          type="text"
          className={`${
            appState.langValue === "ar" ? "IbanTextFieldRtl" : ""
          } w-100`}
          label="Iban"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className="">
                <div className="d-flex mt-2">
                  {/* <EmailIcon className={`${classes.greyColor}`} /> */}
                  {/* <img src={kuwaitFlag} alt="kuwaitFlag" height="25px"  /> */}

                  <p className="ml-1 mt-2">KW</p>
                </div>
              </InputAdornment>
            ),
          }}
        />
        {!ibanNumber? <div className="col-12 text-center mt-4">
          <Button
            variant="contained"
            type="submit"
            //   className={`${buttonClassname} bg-primary login_btn`}
            disabled={
              loading == true
                ? true
                : false || updateData.iban !== ""
                ? false
                : true
            }
            color="primary"
          >
            {loading ? "Do KYC" : "Do KYC"}
          </Button>
          {loading && (
            <CircularProgress size={24} className={classes.buttonProgress} />
          )}
        </div>:""}
       
      </form>
    </div>
  );
}

export default KYC;
